/*
* @Des 组件 历史轨迹
* @Description
* @Author
* @Date 2023/5/30
*/
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;历史数据&ensp;&gt;&ensp;设备历史记录</span>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<GpsTagTracker ref="GpsTagTracker" />
    </div>
</template>

<script>
	// 引入组件 轨迹数据
	import GpsTagTracker from '@/components_outdoor/Outdoor/GpsTagTracker'

	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2023/5/30
		 */
		name: 'OutdoorTrack',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2023/5/30
		 */
		components: {
			// 组件 轨迹数据
			GpsTagTracker,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2023/5/30
		 */
		props: {

		},

		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2023/5/30
		 */
		created() {
			// 开启订阅消息
			// this.startSubscribes();
		},
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2023/5/30
		 */
		mounted() {

		},
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2023/5/30
		 */
		beforeDestroy() {
			// 取消订阅消息
			// this.endSubscribes();
		},

		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2023/5/30
		 */
		data() {
			return {
				// 当前选中 标签
				activeName: 'first',
				/**
				 * @Des 轨迹数据
				 * @Auth
				 * @Date 2023/5/30
				 */
				trackInfo: {},
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2023/5/30
		 */
		methods: {
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
              // 路由 子模块 name
              this.routerSubName = '';
              // 跳转到 首页
              this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter

            /**
             * @Des 点击tab标签(之前)
             * @Auth
             * @Date 2023/5/30
             */
            beforeHandle(tab, event){
            },

			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date 2023/5/30
			 */
			startSubscribes() {
				// 订阅消息 人员轨迹数据
				/*this.sub_trackInfo = this.$pubsub.subscribe('trackInfo', (name, data) => {
					// 轨迹数据
					this.trackInfo = Object.assign({}, data);
				});*/
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date 2023/5/30
			 */
			endSubscribes() {
				//取消订阅 相关信息
				// this.$pubsub.unsubscribe(this.sub_trackInfo);
			},
			//========================== 订阅消息 end ==========================
			
		},// methods

	}// export default
</script>

/* CSS */
<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/views/system-outdoor/outdoor/OutdoorTrack.vue